import axios from 'axios';
import ConfigConnection from '../config/config.service';
export default class LoginService{
  // API Instance
  configConnection: any = new ConfigConnection();

  login(user){
    const _ = this;
    console.log(user, ' User in service')
    return axios.post(`${_.configConnection.apiInstance}login`, user);
  }

  restorePassword(user){
    const _ = this;
    return axios.post(`${_.configConnection.apiInstance}recovery`, user);
  }

  edit(user, token){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    console.log(user);
    console.log(config);
    return axios.post(`${_.configConnection.apiInstance}recovery/password-reset`, user, config);
  }
}
